/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Link_Target_New_TabInputs */

const en_enum_link_target_new_tab = /** @type {(inputs: Enum_Link_Target_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Tab`)
};

const de_enum_link_target_new_tab = /** @type {(inputs: Enum_Link_Target_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Tab`)
};

/**
* | output |
* | --- |
* | "New Tab" |
*
* @param {Enum_Link_Target_New_TabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_link_target_new_tab = /** @type {((inputs?: Enum_Link_Target_New_TabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Link_Target_New_TabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_link_target_new_tab(inputs)
	return de_enum_link_target_new_tab(inputs)
});